// extracted by mini-css-extract-plugin
export default {"highlight":"highlight__index__xvaCf"};